module.exports = __webpack_public_path__ + "static/media/project_design_1_2.efd74f3e.webp";